// extracted by mini-css-extract-plugin
export default {"size":"ReturnAndRefund_size__QpkmQ"};